"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVirtualParent = void 0;
var dom_utilities_1 = require("@fluentui/dom-utilities");
Object.defineProperty(exports, "getVirtualParent", { enumerable: true, get: function () { return dom_utilities_1.getVirtualParent; } });
//# sourceMappingURL=getVirtualParent.js.map